// IMPORTANT: This file is auto generated from writePlaygroundPages
// Any changes you make to this file here will be overwritten.

import * as React from 'react';
import { AccordionPlayground } from './playgrounds/AccordionPlayground';
import { AlertInlineMainPlayground } from './playgrounds/AlertInlineMainPlayground';
import { SnackBarPlayground } from './playgrounds/SnackBarPlayground';
import { SuccessToasterPlayground } from './playgrounds/SuccessToasterPlayground';
import { WarningPopupPlayground } from './playgrounds/WarningPopupPlayground';
import { AppSideDisplayPlayground } from './playgrounds/AppSideDisplayPlayground';
import { AppTitleBarPlayground } from './playgrounds/AppTitleBarPlayground';
import { AudioPlayerPlayground } from './playgrounds/AudioPlayerPlayground';
import { ImageCarouselPlayground } from './playgrounds/ImageCarouselPlayground';
import { VideoPlayerPlayground } from './playgrounds/VideoPlayerPlayground';
import { BasicTilePlayground } from './playgrounds/BasicTilePlayground';
import { WaveTilePlayground } from './playgrounds/WaveTilePlayground';
import { BigNumberPlayground } from './playgrounds/BigNumberPlayground';
import { ChartWrapperPlayground } from './playgrounds/ChartWrapperPlayground';
import { CalendarPlayground } from './playgrounds/CalendarPlayground';
import { ColorPickerPlayground } from './playgrounds/ColorPickerPlayground';
import { DatePickerPlayground } from './playgrounds/DatePickerPlayground';
import { HierarchyPickerPlayground } from './playgrounds/HierarchyPickerPlayground';
import { LeftRightPickerPlayground } from './playgrounds/LeftRightPickerPlayground';
import { TreePickerPlayground } from './playgrounds/TreePickerPlayground';
import { CheckboxPlayground } from './playgrounds/CheckboxPlayground';
import { DefaultButtonPlayground } from './playgrounds/DefaultButtonPlayground';
import { FABPlayground } from './playgrounds/FABPlayground';
import { FilterButtonPlayground } from './playgrounds/FilterButtonPlayground';
import { HeadingButtonPlayground } from './playgrounds/HeadingButtonPlayground';
import { IconButtonPlayground } from './playgrounds/IconButtonPlayground';
import { SentimentButtonPlayground } from './playgrounds/SentimentButtonPlayground';
import { TileButtonPlayground } from './playgrounds/TileButtonPlayground';
import { CloudPillPlayground } from './playgrounds/CloudPillPlayground';
import { CustomPillPlayground } from './playgrounds/CustomPillPlayground';
import { CommentPlayground } from './playgrounds/CommentPlayground';
import { CondensedExperienceCardPlayground } from './playgrounds/CondensedExperienceCardPlayground';
import { ExperienceCardPlayground } from './playgrounds/ExperienceCardPlayground';
import { ExperienceHeaderPlayground } from './playgrounds/ExperienceHeaderPlayground';
import { NotesPlayground } from './playgrounds/NotesPlayground';
import { DrawerPlayground } from './playgrounds/DrawerPlayground';
import { SidePanelPlayground } from './playgrounds/SidePanelPlayground';
import { DropdownPlayground } from './playgrounds/DropdownPlayground';
import { EditableTextPlayground } from './playgrounds/EditableTextPlayground';
import { InputFieldPlayground } from './playgrounds/InputFieldPlayground';
import { TextAreaPlayground } from './playgrounds/TextAreaPlayground';
import { GenericModalPlayground } from './playgrounds/GenericModalPlayground';
import { PopoutPlayground } from './playgrounds/PopoutPlayground';
import { HorizontalTabBarPlayground } from './playgrounds/HorizontalTabBarPlayground';
import { TabBarPlayground } from './playgrounds/TabBarPlayground';
import { VerticalTabBarPlayground } from './playgrounds/VerticalTabBarPlayground';
import { ListPlayground } from './playgrounds/ListPlayground';
import { ProgressBarPlayground } from './playgrounds/ProgressBarPlayground';
import { XIAnimationPlayground } from './playgrounds/XIAnimationPlayground';
import { XIAppIconPlayground } from './playgrounds/XIAppIconPlayground';
import { XIIconPlayground } from './playgrounds/XIIconPlayground';
import { XISVGPlayground } from './playgrounds/XISVGPlayground';
import { RadioPlayground } from './playgrounds/RadioPlayground';
import { SearchBoxPlayground } from './playgrounds/SearchBoxPlayground';
import { SliderPlayground } from './playgrounds/SliderPlayground';
import { TablePlayground } from './playgrounds/TablePlayground';
import { ToggleSwitchPlayground } from './playgrounds/ToggleSwitchPlayground';
import { ToggleTextPlayground } from './playgrounds/ToggleTextPlayground';
import { ToolTipContentPlayground } from './playgrounds/ToolTipContentPlayground';

export interface Props {
  componentName: string;
}

export const Playground: React.FC<Props> = (props) => {
  switch (props.componentName) {
    case 'Accordion':
      return <AccordionPlayground />;
    case 'AlertInlineMain':
      return <AlertInlineMainPlayground />;
    case 'SnackBar':
      return <SnackBarPlayground />;
    case 'SuccessToaster':
      return <SuccessToasterPlayground />;
    case 'WarningPopup':
      return <WarningPopupPlayground />;
    case 'AppSideDisplay':
      return <AppSideDisplayPlayground />;
    case 'AppTitleBar':
      return <AppTitleBarPlayground />;
    case 'AudioPlayer':
      return <AudioPlayerPlayground />;
    case 'ImageCarousel':
      return <ImageCarouselPlayground />;
    case 'VideoPlayer':
      return <VideoPlayerPlayground />;
    case 'BasicTile':
      return <BasicTilePlayground />;
    case 'WaveTile':
      return <WaveTilePlayground />;
    case 'BigNumber':
      return <BigNumberPlayground />;
    case 'ChartWrapper':
      return <ChartWrapperPlayground />;
    case 'Calendar':
      return <CalendarPlayground />;
    case 'ColorPicker':
      return <ColorPickerPlayground />;
    case 'DatePicker':
      return <DatePickerPlayground />;
    case 'HierarchyPicker':
      return <HierarchyPickerPlayground />;
    case 'LeftRightPicker':
      return <LeftRightPickerPlayground />;
    case 'TreePicker':
      return <TreePickerPlayground />;
    case 'Checkbox':
      return <CheckboxPlayground />;
    case 'DefaultButton':
      return <DefaultButtonPlayground />;
    case 'FAB':
      return <FABPlayground />;
    case 'FilterButton':
      return <FilterButtonPlayground />;
    case 'HeadingButton':
      return <HeadingButtonPlayground />;
    case 'IconButton':
      return <IconButtonPlayground />;
    case 'SentimentButton':
      return <SentimentButtonPlayground />;
    case 'TileButton':
      return <TileButtonPlayground />;
    case 'CloudPill':
      return <CloudPillPlayground />;
    case 'CustomPill':
      return <CustomPillPlayground />;
    case 'Comment':
      return <CommentPlayground />;
    case 'CondensedExperienceCard':
      return <CondensedExperienceCardPlayground />;
    case 'ExperienceCard':
      return <ExperienceCardPlayground />;
    case 'ExperienceHeader':
      return <ExperienceHeaderPlayground />;
    case 'Notes':
      return <NotesPlayground />;
    case 'Drawer':
      return <DrawerPlayground />;
    case 'SidePanel':
      return <SidePanelPlayground />;
    case 'Dropdown':
      return <DropdownPlayground />;
    case 'EditableText':
      return <EditableTextPlayground />;
    case 'InputField':
      return <InputFieldPlayground />;
    case 'TextArea':
      return <TextAreaPlayground />;
    case 'GenericModal':
      return <GenericModalPlayground />;
    case 'Popout':
      return <PopoutPlayground />;
    case 'HorizontalTabBar':
      return <HorizontalTabBarPlayground />;
    case 'TabBar':
      return <TabBarPlayground />;
    case 'VerticalTabBar':
      return <VerticalTabBarPlayground />;
    case 'List':
      return <ListPlayground />;
    case 'ProgressBar':
      return <ProgressBarPlayground />;
    case 'XIAnimation':
      return <XIAnimationPlayground />;
    case 'XIAppIcon':
      return <XIAppIconPlayground />;
    case 'XIIcon':
      return <XIIconPlayground />;
    case 'XISVG':
      return <XISVGPlayground />;
    case 'Radio':
      return <RadioPlayground />;
    case 'SearchBox':
      return <SearchBoxPlayground />;
    case 'Slider':
      return <SliderPlayground />;
    case 'Table':
      return <TablePlayground />;
    case 'ToggleSwitch':
      return <ToggleSwitchPlayground />;
    case 'ToggleText':
      return <ToggleTextPlayground />;
    case 'ToolTipContent':
      return <ToolTipContentPlayground />;
    default:
      return <div />;
  }
};
